<template>
  <v-dialog v-model="dialog" :max-width="500" @keydown.esc="cancel()">
    <v-card tile>
      <v-card-title class="headline" primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text v-if="!!message">{{ message }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.native="agree()">{{$t("Yes")}}</v-btn>
        <v-btn color="success" @click.native="cancel()">{{$t("Cancel")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null
    }
  },
  methods: {
    open (title, message) {
      this.dialog = true
      this.title = title
      this.message = message
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
